import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'

import { AutocompleteComponent } from './autocomplete.component'
import { CustomMaterialModule } from '../material/custom-material.module'
import { ButtonModule } from '../button/button.module'
import { ListItemModule } from '../list-item/list-item.module'
import { AutocompletePaginatedComponent } from './autocomplete-paginated.component'
/**
 * Created by sange on 26/07/2017.
 */

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    ButtonModule,
    ListItemModule,
  ],
  declarations: [
    AutocompleteComponent,
    AutocompletePaginatedComponent,
  ],
  exports: [
    AutocompleteComponent,
    AutocompletePaginatedComponent,
  ],
})
export class AutocompleteModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/autocomplete/autocomplete.module.ts